export const MIN_ADA_BRIDGE = 2;
export const MILKOMEDA_APPROVE_FEE = 0.04;

export const DEFAULT_BRIDGE_DECIMALS = 6;
